import {
  Directive,
  Input,
  Output,
  HostBinding,
  EventEmitter,
  OnDestroy,
  OnInit,
  OnChanges,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { SortableService } from './sortable.service';


@Directive({
  selector: 'sortable-container, [sortableContainer]',
  exportAs: 'sortable-container',
})
export class SortableContainerDirective implements OnInit, OnDestroy, OnChanges {

  @Input() data: any[];

  @Input() currentSortableField: string;

  @Input() backendSorting: boolean = false;

  @Output() public dataChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  private subscription: Subscription;

  constructor(
    private sortableService: SortableService
  ) {}

  ngOnInit() {
    this.sortableService.init(this.data, this.backendSorting);
    this.subscription = this.sortableService.sortData.subscribe((data: any) => {
      this.dataChange.emit(data);
    });
  }

  ngOnChanges() {
    this.sortableService.setData(this.data);
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
    this.sortableService.reset();
  }
}
